import API from '@/shared/plugins/Api/API'

class ModulesV3 extends API {
  constructor (id) {
    super(id)
    this.prefix = '/public/v1'
  }

  _tagUrl (appName, tagName) {
    return `${this.prefix}/application/${encodeURIComponent(appName)}/tag/${encodeURIComponent(tagName)}`
  }

  async list (appName, tagName) {
    const response = await this.request({
      method: 'get',
      url: `${this._tagUrl(appName, tagName)}/module`
    })
    return response
  }

  async install (appName, tagName, moduleName, version = 'latest') {
    const response = await this.request({
      method: 'post',
      url: `${this._tagUrl(appName, tagName)}/module`,
      data: { moduleName, version }
    })
    return response
  }

  async update (appName, tagName, moduleName, version = 'latest') {
    const response = await this.request({
      method: 'put',
      url: `${this._tagUrl(appName, tagName)}/module/${encodeURIComponent(moduleName)}`,
      data: { version }
    })
    return response
  }

  async remove (appName, tagName, moduleName) {
    await this.request({
      method: 'delete',
      url: `${this._tagUrl(appName, tagName)}/module/${encodeURIComponent(moduleName)}`
    })
  }
}

export default ModulesV3
